export const countryCodeOptions = ["US", "CA"];